import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue"
import CompanyDetailsInfoForm, {
  CompanyProfile,
} from "@/modules/Clients/ClientDetail/CompanyDetailsInfoForm.vue"
import {
  ClientInformationQuery,
  ClientInformationQueryQuery,
  ClientInformationQueryQueryVariables,
  MissionRequestBusinessIndustry,
} from "@/gql"
import { useQuery } from "@vue/apollo-composable"
import { useAccountContext } from "@/hooks/useAccountContext"


export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyInformationTab',
  setup(__props) {

const companyInfo = ref<CompanyProfile | null>(null)
const { client } = useAccountContext()

const { loading, onResult } = useQuery<
  ClientInformationQueryQuery,
  ClientInformationQueryQueryVariables
>(ClientInformationQuery, {
  id: client?.prn || "",
})

onResult((result) => {
  if (result?.data?.myClient) {
    const client = result.data.myClient

    companyInfo.value = {
      name: client.name,
      clientId: client.prn,
      address: client.address,
      description: client.description || "",
      countryId: client.country.id,
      industry: client.industry as MissionRequestBusinessIndustry,
      website: client.website || "",
    }
  }
})

return { __sfc: true,companyInfo, client, loading, onResult, CompanyDetailsInfoForm }
}

})